<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <ul class="swiper-slide" v-for="(item,i) in currentList" ref="ul" :key="i">
          <li v-for="(k,j) in item" @click="setCurrent(j,k.sendDate)" :key="j">
            <p>{{k.week}}</p>
            <span style="display: none;">{{k.sendDate}}</span>
            <i class="iconfont icon-jin" v-if="k.now"></i>
            <span v-else :class="[{active:nowDateStr==k.sendDate},{checked:currentIndex==j}]">{{k.showDate}}</span>
            <span :class="{dot:nowDateStr!=k.sendDate}" v-if="k.list&&k.list.length>0&&nowDateStr!=k.sendDate"></span>
          </li>
        </ul>
      </div>
      <div class="cateory" :style="{left:cateLeft+'px'}"><i></i></div>
    </div>
    <div class="lession-list">
      <div v-if="!newCalendarListArr" class="nodata">
        <p>当天暂无直播</p>
      </div>
      <ul v-if="newCalendarListArr&&newCalendarListArr.length>0">
        <div class="template-div" v-for="(item, i) in newCalendarListArr" :key="i">
          <li v-if="i==0 && !isShow" @click='go_zhibo(item)'>
            <div class="left-div">
              <p class="time">{{getTime(Number(item.start_time)*1000)}}</p>
              <p class="tagtip" v-if="(Number(item.start_time)-3600>new Date().getTime()/1000)">未开始</p>
              <p class="tag" v-if="nowDateStr==dateStr&&Number(item.start_time)-3600<new Date().getTime()/1000&&Number(item.start_time)>new Date().getTime()/1000">即将开始</p>
              <p class="tag" v-if="!item.noLivePush&&nowDateStr==dateStr&&Number(item.start_time)<new Date().getTime()/1000&&new Date().getTime()/1000<Number(item.end_time)+9000">直播中</p>
              <p class="tagtip" v-if="item.noLivePush&&item.offline_code">看回放</p>
              <p class="tagtip" v-if="item.noLivePush&&item.offline_code==''">已结束</p>
            </div>
            <p class="placeholder"></p>
            <div class="right-div">
              <p class="lesson-name">{{item.lesson_name}}</p>
              <p class="package-name">{{item.package_name}}</p>
            </div>
          </li>
          <li v-if="isShow" @click='go_zhibo(item)'>
            <div class="left-div">
              <p class="time">{{getTime(Number(item.start_time)*1000)}}</p>
              <p class="tagtip" v-if="(Number(item.start_time)-3600>new Date().getTime()/1000)">未开始</p>
              <p class="tag" v-if="nowDateStr==dateStr&&Number(item.start_time)-3600<new Date().getTime()/1000&&Number(item.start_time)>new Date().getTime()/1000">即将开始</p>
              <p class="tag" v-if="!item.noLivePush&&nowDateStr==dateStr&&Number(item.start_time)<new Date().getTime()/1000&&new Date().getTime()/1000<Number(item.end_time)+9000">直播中</p>
              <p class="tagtip" v-if="item.noLivePush&&item.offline_code">看回放</p>
              <p class="tagtip" v-if="item.noLivePush&&item.offline_code==''">已结束</p>
            </div>
            <p class="placeholder"></p>
            <div class="right-div">
              <p class="lesson-name">{{item.lesson_name}}</p>
              <p class="package-name">{{item.package_name}}</p>
            </div>
          </li>
        </div>
        <p class="operate-btn" v-if="newCalendarListArr&&newCalendarListArr.length>1" @click="showAll()">{{isShow?"收起":'展开更多'}}<i
            class="updown" :class="[{'el-icon-arrow-down':!isShow},{'el-icon-arrow-up':isShow}]"></i></p>
      </ul>
    </div>
    <div class="class_dialog" v-if='zujian_flag'>
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br />你可在"{{ appname }}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
            :extinfo="JSON.stringify({'type': 1, 'orderSn': sn, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href="scheme+'?type=1&orderSn='+ sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        </p>
      </div>
    </div>
    <popup :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
    <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import popup from "../popup/index" //小程序弹窗
  import wxapp from '../../utils/wxapp.js'
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  import arouse from '../arouse/index.vue'
  import {
    Toast
  } from "vant";

  const cathWidth = +2;
  export default {
    data() {
      return {
        ticket: '',
        ticket_source: '',
        currentList: [],
        currentFirstDate: null,
        currentIndex: new Date().getDay(),
        cateLeft: 0,
        nowDate: this.setNowDate(new Date()),
        calendarList: [],
        newCalendarList: [], //当前展示的日历数据
        newCalendarListArr: [], //某天的详情数据
        nowDateStr: this.timeFormat(new Date().getTime()), //当前日期时间戳
        dateStr: '',
        isShow: false,
        zujian_flag: false,
        ua: navigator.userAgent.toLowerCase(),
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
        ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
        sn: '',
        applets_flag: false,
        isapplets: false,
        detail: '',
        appname: '',
        sf: '',
        arshow: false,
        isweixin: false,
        scheme: ''
      }
    },
    props: ['isLoadCander'],
    components: {
      popup,
      arouse
    },
    created() {
      // 小程序内
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.isapplets = true
        }
      })
      this.now();
      if (!this.$route.query.ticket) {
        this.getRecord();
      }
    },
    methods: {
      receive (val) {
        this.arshow = val
      },
      handleErrorFn(e) {
        this.arshow = true
        console.log(JSON.stringify(e), '跳转失败')
        Toast("当前手机未下载中公教育app");
        // this.download() // 这里跳转App下载页面
      },
      // 监听launch 函数
      handleLaunchFn(e) {
        // 跳转成功
        console.log(JSON.stringify(e), '跳转成功')
      },
      download(){
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
            window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
            window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      },
      handleJudgeWechat() {
        const wechatInfo = window.navigator.userAgent.match(
          /MicroMessenger\/([\d\.]+)/i
        );
        if (!wechatInfo) return;
        let judgewechat = wechatInfo[1].split(".");
        let flag = false;
        if (judgewechat[0] >= 7) {
          if (judgewechat[1] >= 0) {
            if (judgewechat[2] >= 12) {
              this.wechatState = true;
              flag = true;
            }
          }
        }
        if (!flag) {
          Toast.fail('请升级当前微信版本');
          return false
        }
      },
      formatDate(nowDate) {
        let year = nowDate.getFullYear();
        let month = (nowDate.getMonth() + 1);
        let date = nowDate.getDate();
        let week = ['日', '一', '二', '三', '四', '五', '六'][nowDate.getDay()];
        return {
          week,
          showDate: date,
          // listDate: `${month}月${date}日 ${week}`,
          sendDate: `${year}-${month}-${date}`,
          // now: nowDate.toLocaleDateString() === new Date().toLocaleDateString()
        }
      },
      addDate(date, n) {
        date.setDate(date.getDate() + n);
        return date;
      },
      getTime(times) {
        return this.addZeros(new Date(times).getHours()) + ':' + this.addZeros(new Date(times).getMinutes());
      },
      setDate(date) {
        let week = date.getDay();
        date = this.addDate(date, week * -1);
        this.currentFirstDate = new Date(date);
        let list = []
        for (let i = 0; i < 7; i++) {
          list.push(this.formatDate(i === 0 ? this.addDate(date, 0) : this.addDate(date, 1)));
        }
        return list
      },
      currentClassStatus(i, j) {
        return i === 1 && j === this.currentIndex
      },
      setCurrent(j, sendDate) {
        this.currentIndex = j;
        this.nowDate = sendDate;
        this.getDayDetail(this.nowDate);
      },
      setNowDate(nowDate) {
        let year = nowDate.getFullYear();
        let month = (nowDate.getMonth() + 1);
        let date = nowDate.getDate();
        return `${year}-${month}-${date}`;
      },
      init() {
        var mySwiper = new Swiper('.swiper-container', {
          on: {
            slidePrevTransitionStart: () => {},
            slidePrevTransitionEnd: () => {
              mySwiper.slideTo(1, 0, false);
              let pre = this.setDate(this.addDate(this.currentFirstDate, -21)) //11
              let now = this.setDate(this.addDate(this.currentFirstDate, 7)); //18
              let next = this.setDate(this.addDate(this.currentFirstDate, 7)) //25
              this.currentList = [pre, now, next];
              setTimeout(() => {
                this.currentIndex = 0;
                this.nowDate = this.currentList[1][0].sendDate;
              }, 20)
              this.getCompare();

            },
            slideNextTransitionStart: () => {

            },
            slideNextTransitionEnd: () => {
              mySwiper.slideTo(1, 0, false);
              let pre = this.setDate(this.addDate(this.currentFirstDate, -7)) //18
              let now = this.setDate(this.addDate(this.currentFirstDate, 7)); //25
              let next = this.setDate(this.addDate(this.currentFirstDate, 7)) //32
              this.currentList = [pre, now, next];
              setTimeout(() => {
                this.currentIndex = 6;
                this.nowDate = this.currentList[1][6].sendDate;
              }, 20)
              this.getCompare();

            },
          },
        })
        mySwiper.slideTo(1, 0, false);
        this.$nextTick(() => {
          this.cateLeft = Math.abs(this.$refs.ul[1].children[this.currentIndex].getBoundingClientRect().left +
            cathWidth)
        })
      },
      getNow() {
        this.now()
        this.nowDate = this.setNowDate(new Date())
        this.currentIndex = new Date().getDay();
      },
      now() {
        let now = this.setDate(new Date());
        let pre = this.setDate(this.addDate(this.currentFirstDate, -7))
        let next = this.setDate(this.addDate(this.currentFirstDate, 14));
        this.currentList = [pre, now, next];
      },
      getRecord() {
        this.ticket = JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"];
        this.ticket_source = JSON.parse(localStorage.getItem("ticketObj")).ticket_source;
        this.$api.GETCALENDAR({
          "offcn-ticket": this.ticket,
          ticket_source: this.ticket_source,
        }).then((res) => {
          if (res.code == 0) {
            this.calendarList = res.data.calendar;
            this.getCompare();
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
      },
      getCompare() {
        let newCurrentList = [];
        for (let i in this.currentList) {
          for (let j in this.currentList[i]) {
            newCurrentList.push(this.currentList[i][j]);
          }
        }
        for (let i = 0; i < this.calendarList.length; i++) {
          for (let j in newCurrentList) {
            if (this.timeFormat(this.calendarList[i].timestamp * 1000) == newCurrentList[j].sendDate) {
              newCurrentList[j].list = this.calendarList[i].list;
            }
          }
        }
        this.currentList = [newCurrentList.slice(0, 7), newCurrentList.slice(7, 14), newCurrentList.slice(14, 21)];
        this.newCalendarList = [newCurrentList.slice(7, 14)];
        console.log(this.currentList, 'currentList');
        this.getDayDetail();
      },
      // 查询直播是否断流
      async checkRoomState (data) {
        return new Promise((resolve, reject) => {
          this.$api.CheckRoomState(data).then((res) => {
            if (res.code === 0) {
              resolve(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      async getDayDetail(date) {
        let that = this;
        if (date) {
          this.dateStr = date;
        } else {
          this.dateStr = this.timeFormat(new Date().getTime());
        }
        for (let i in this.newCalendarList[0]) {
          if (this.newCalendarList[0][i].sendDate == this.dateStr) {
            let listData = this.newCalendarList[0][i].list
            let endLiveList = []
            listData.forEach(e => {
              if (Number(e.end_time) + 9000 > new Date().getTime() / 1000 && Number(e.end_time) < new Date().getTime() / 1000) {
                // 直播结束2.5小时之内
                endLiveList.push({
                  roomId: e.room_id,
                  endTime: Number(e.end_time)
                })
                that.$nextTick(() => {
                  Object.assign(e, {
                    noLivePush: false
                  })
                })
              } else if (Number(e.end_time) + 9000 < new Date().getTime() / 1000) {
                // 直播结束2.5小时之外
                that.$nextTick(() => {
                  Object.assign(e, {
                    noLivePush: true
                  })
                })
              } else {
                // 直播没结束其他情况
                that.$nextTick(() => {
                  Object.assign(e, {
                    noLivePush: false
                  })
                })
              }
            })
            if (endLiveList.length > 0) {
              await that.checkRoomState({
                rooms: endLiveList.map(a => a.roomId)
              }).then(data => {
                data.forEach(e => {
                  if (e.is_push === 0) {
                    that.$nextTick(() => {
                       Object.assign(listData.find(i => i.room_id === e.room_num), {noLivePush: true})
                    })
                    let rIndex = endLiveList.findIndex(b => b.roomId === e.room_num)
                    if (rIndex > -1) {
                      endLiveList.splice(rIndex, 1)
                    }
                  }
                })
              })
            }
            let timer = setInterval(async () => {
              endLiveList.forEach(c => {
                if (c.endTime + 9000 <= new Date().getTime() / 1000) {
                  // 超出2.5小时了
                  that.$nextTick(() => {
                    Object.assign(listData.find(i => i.room_id === c.room_num), {noLivePush: true})
                  })
                  let rIndex = endLiveList.findIndex(b => b.roomId === c.room_num)
                  if (rIndex > -1) {
                    endLiveList.splice(rIndex, 1)
                  }
                }
              })
              if (endLiveList.length > 0) {
                await that.checkRoomState({
                  rooms: endLiveList.map(a => a.roomId)
                }).then(data => {
                  data.forEach(e => {
                    if (e.is_push === 0) {
                      that.$nextTick(() => {
                        Object.assign(listData.find(i => i.room_id === e.room_num), {noLivePush: true})
                      })
                      let rIndex = endLiveList.findIndex(b => b.roomId === e.room_num)
                      if (rIndex > -1) {
                        endLiveList.splice(rIndex, 1)
                      }
                    }
                  })
                })
              } else {
                clearInterval(timer)
              }
            }, 180000)
            this.$nextTick(() => {
              this.newCalendarListArr = listData;
            })
          }
        }
      },
      //时间戳处理，不足10补0
      addZeros(m) {
        return m < 10 ? "0" + m : m;
      },
      //时间戳处理，不足10补0
      addZero(m) {
        // return m < 10 ? "0" + m : m;
        return m;
      },
      timeFormat(timestamp) {
        var time = "";
        time = new Date(timestamp);
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        return (
          year + "-" + this.addZero(month) + "-" + this.addZero(date)
        );
      },
      showAll() {
        this.isShow = !this.isShow;
      },
      go_zhibo(item) {
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.course_id,
          coding: item.cid,
          menu_id: item.lesson_id
        }).then((res) => {
          if (res.code == 0) {
            let info = res.data.catalog.info
            if (item.lesson_type == 3) {
              if (item.learning_style && item.learning_style.indexOf(2) == -1) {
                this.detail = item
                this.detail.order_id = this.$route.query.order_id
                this.detail.package_id = item.course_id
                this.detail.cid = item.cid
                this.detail.shopid = this.shopid
                if (this.isapplets) {
                  this.applets_flag = true
                } else {
                  this.sn = item.system_order
                  this.zujian_flag = true
                }
              } else {
                if (item.offline_code) {
                  location.href = item.url_online
                } else {
                  location.href = item.url_liveshow
                }
              }
              // this.$router.push({
              //   path: "/livevod",
              //   query: {
              //     order_id: item.system_order,
              //     package_id: item.package_id,
              //     cid: item.cid,
              //     unit_id: item.lesson_id,
              //     live_type: 1,
              //     module_type: 6,
              //     url: item.url_liveshow
              //   }
              // })
            } else if (item.lesson_type == 9) {
              if (item.learning_style && item.learning_style.indexOf(2) == -1) {
                this.detail = item
                this.detail.order_id = this.$route.query.order_id
                this.detail.package_id = item.course_id
                this.detail.cid = item.cid
                this.detail.shopid = this.shopid
                if (this.isapplets) {
                  this.applets_flag = true
                } else {
                  this.zujian_flag = true
                  this.sn = item.system_order
                }
              } else {
                let liveStatus = null
                // 直播状态 0:未开始 1:即将开始 2:直播中 3:已结束有回放
                if ((Number(item.start_time) - 3600 > new Date().getTime() / 1000)) {
                  liveStatus = 0
                } else if (Number(item.start_time) - 3600 < new Date().getTime() / 1000 && Number(item.start_time) > new Date().getTime() / 1000) {
                  liveStatus = 1
                } else if (!item.noLivePush && Number(item.start_time) < new Date().getTime() / 1000 && new Date().getTime() / 1000 < Number(item.end_time) + 9000) {
                  liveStatus = 2
                } else if (item.noLivePush && item.offline_code) {
                  liveStatus = 3
                }
                if (liveStatus === 1 || liveStatus === 2) {
                  this.$router.push({
                    path: "/livevod",
                    query: {
                      order_id: item.system_order,
                      package_id: item.course_id,
                      cid: item.cid,
                      unit_id: item.lesson_id,
                      module_type: 6,
                      url: info.live_record_url
                    }
                  })
                } else if (liveStatus === 0) {
                  Toast("直播未开始");
                } else if (liveStatus === 3) {
                  this.$router.push({
                    path: "/livevod",
                    query: {
                      order_id: item.system_order,
                      package_id: item.course_id,
                      cid: item.cid,
                      unit_id: item.lesson_id,
                      live_type: 3,
                      module_type: 66,
                      url: info.live_record_url
                    }
                  })
                } else {
                  Toast("暂无回放");
                }
              }
            } else {
              if (this.isapplets) {
                this.applets_flag = true
              } else {
                this.zujian_flag = true
                this.$nextTick(() => {
                  var btn = document.getElementById('launch-btn')
                  btn.addEventListener('launch', function(e) {
                    this.handleJudgeWechat(); //是否满足跳转app条件
                  });
                })
              }
            }
          } else if (res.code == 2) {
            this.$router.push({
              path: "/"
            });
          }
        })
      },
      cancel_flag() {
        this.zujian_flag = false
      },
      popup () {
        this.applets_flag = false;
      },
      search_flag() {
        if(!this.isweixin){
          this.arshow = false;
          if (this.sf == 'zxkt' || this.sf == 'zgwx') {
            location.href = 'https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'zgtk') {
            location.href = 'https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'sydw') {
            location.href = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'zgzsb') {
            location.href = 'https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'zgyljy') {
            location.href = 'https://www.eoffcn.com/zg_yikao/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'zgky') {
            location.href = 'https://www.eoffcn.com/zg_postgraduate/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
          } else if (this.sf == 'zgjsgc') {
            this.openApp('https://www.zggcks.com/zg/2021jgapp/')
          } else if (this.sf == 'zgyouzhi'){
            if (this.android) {
              var SERVER_BASE_URL
              if (process.env.NODE_ENV=='production') {
                SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
              } else {
                SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
              }
              this.openApp(SERVER_BASE_URL);
            } else if (this.ios) {
              location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
          } else {
            if (this.android) {
              var SERVER_BASE_URL
              if (process.env.NODE_ENV=='production') {
                SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
              } else {
                SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
              }
              this.openApp(SERVER_BASE_URL);
            } else if (this.ios) {
              location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
          }
        }else{
          this.arshow = true;
        }
      },
      openApp(src) {
        var d = new Date()
        var t0 = d.getTime()
        var delay = setInterval(function() {
          var d = new Date();
          var t1 = d.getTime();
          if (t1 - t0 < 3000 && t1 - t0 > 2000) {
            window.location.href = src;
          }
          if (t1 - t0 >= 3000) {
            clearInterval(delay);
          }
        }, 2000);
      }
    },
    mounted() {
      wxapp.init()
      this.init();
      window.onresize = () => {
        this.init();
      }
      this.sf = this.$route.query.sf
      if (this.sf == 'zxkt') {
        this.appid = 'wx1062070e19e76b81'
        this.appname = '中公网校'
        this.scheme = 'zaixianketang://'
        this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
      } else if (this.sf == 'zgwx') {
        this.appid = 'wx1062070e19e76b81'
        this.appname = '中公网校'
        this.scheme = 'zaixianketang://'
        this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
      } else if (this.sf == 'sydw') {
        this.appid = 'wx4161c8d806017e0d'
        this.appname = '事业单位'
        this.scheme = 'shiyedanwei://'
        this.open_url = 'http://3min-class.offcn.com/videos/h5/download/institution/'
      } else if (this.sf == 'zgtk') {
        this.appname = '中公题库'
        this.scheme = 'zhonggongtiku://openapp'
        this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
      } else if (this.sf == 'zgzsb') {
        this.appid = 'wx9487d9bc65834b47'
        this.appname = '中公专升本'
        this.scheme = 'zhonggongzhuanshengben://openapp'
        this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
      } else if (this.sf == 'zgyljy'){
        this.appid = 'wxc7238886c470203e'
        this.appname = '中公医疗教育'
        this.scheme = 'zhonggongyiliaojiaoyu://openapp'
        this.open_url = 'https://www.eoffcn.com/zg_yikao'
      } else if (this.sf == 'zgjsgc') {
        this.appname = '中公建设工程'
        this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
      } else if (this.sf == 'zgyouzhi') {
        this.appid = 'wx91652b0b55a2ca52'
        this.appname = '优职'
        this.scheme = 'zgyouzhi://openapp'
      } else {
        this.appid = 'wx4a8209bce2ce2a1d'
        this.appname = '中公教育'
        this.scheme = 'zhonggongjiaoyu://openapp'
      }
      //是否是微信浏览器
      if (/(micromessenger)/i.test(navigator.userAgent)) {
        //是否电脑微信或者微信开发者工具
        if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
          console.log('电脑微信或者微信开发者工具')
          this.isweixin = false;
        }else{
          //手机微信打开的浏览器
          console.log('手机微信')
          this.isweixin = true;
        }
      } else {
        console.log('其他浏览器')
        this.isweixin = false;
      }
    },
    watch: {
      currentIndex(val) {
        this.cateLeft = Math.abs(this.$refs.ul[1].children[val].getBoundingClientRect().left + cathWidth);
      },
      isLoadCander(val) {
        // console.log(this.isLoadCander,'isLoadCander');
        if (this.isLoadCander) {
          this.getRecord();
        }
      }
    },
  }
</script>
<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  #launch-btn {
    position: absolute;
    right: 0;
    width: 242px;
    height: 68px;
    opacity: 0;
  }

  .swiper-container {
    position: relative;
    overflow: hidden;

    .cateory {
      width: 20px;
      height: 16px;
      position: absolute;
      left: 0;
      bottom: -2px;
      z-index: 10;
      text-align: center;
      transition: all 0.2s ease-in;

      i {
        font-size: 12px;
        color: #ffffff;
        display: inline-block;
        vertical-align: bottom;
      }
    }
  }

  .swiper-slide {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    li {
      color: #fff;
      font-size: 11px;
      text-align: center;
      flex: 1;
      position: relative;

      p {
        font-size: 22px;
        opacity: 0.7;
        color: #666;
        text-align: center;
        margin-bottom: 25px;
      }

      span {
        margin-top: 5px;
        display: inline-block;
        color: #333;
        font-size: 36px;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
      }

      .checked {
        background: #e8e8e8;
        border-radius: 50%;
      }

      .active {
        text-align: center;
        background-image: linear-gradient(0deg, #d33f3a 0%, #d75b4a 100%), linear-gradient(#e60012, #e60012);
        box-shadow: 0rem 0.07rem 0.2rem 0rem rgba(164, 28, 19, 0.3);
        color: #fff;
        border-radius: 50%;
      }

      .dot {
        width: 8px;
        height: 8px;
        background: #e60012;
        border-radius: 100%;
        position: absolute;
        border-radius: 50%;
        bottom: 41px;
        right: 20px;
      }

      i {
        font-size: 20px;
        display: inline-block;
        margin-top: 2px;
      }
    }
  }

  .lession-list {
    margin-top: 30px;

    li {
      width: 686px;
      height: 135px;
      background: #f6f6f6;
      border-radius: 8px;
      margin-bottom: 15px;
      padding: 23px 30px;
      display: flex;
      height: 100%;

      // .template-div {
      //   display: flex;
      //   height: 100%;
      // }
      .placeholder {
        width: 1px;
        height: 100%;
        border: dashed 1px #cccccc;
        margin: 0 14px;
      }

      .time {
        color: #4a4a4a;
        font-size: 34px;
        text-align: center;
      }

      .left-div {
        padding-right: 30px;
        border-right: 1px dashed #cccccc;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .right-div {
        width: 70%;
      }

      .lesson-name {
        color: #4a4a4a;
        font-size: 28px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }

      .package-name {
        color: #999999;
        font-size: 22px;
        margin-top: 19px;
      }

      .tag {
        font-size: 20px;
        margin-top: 10px;
        background: #ffffff;
        border-radius: 5px;
        border: solid 1px #e60012;
        text-align: center;
        color: #e60012;
        padding: 4px 14px;
        display: inline-block;
      }

      .tagtip {
        font-size: 20px;
        margin-top: 10px;
        border-radius: 5px;
        color: #999999;
        border: 1px solid #999999;
        text-align: center;
        padding: 4px 14px;
        display: inline-block;
      }
    }

    .operate-btn {
      color: #999999;
      text-align: center;
    }
  }

  .date {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: start;
    padding: 20px 10px;

    span {
      font-size: 18px;

      &:last-of-type {
        display: inline-block;
        padding: 5px 10px;
        color: #ffffff;
        background: #4d7eff;
        border-radius: 5px;
      }
    }
  }

  .updown {
    font-weight: bold;
    margin-left: 10px;
  }

  .nodata {
    text-align: center;
    color: #666;

    img {
      display: inline-block;
      width: 250px;
      height: 187px;
      margin-bottom: 40px;
    }
  }

  .class_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 1;

    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;

      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }

      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;

        span {
          flex: 1;
          text-align: center;
        }

        .goapp {
          color: #e60012;
          border-left: 1px solid #e5e5e5;
        }
      }
    }
  }
  .popop_content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/loop.vue